export enum AnalysisCalculationLevel {
  LOWEST = 'lowest',
  HIGHEST = 'highest',
}
